import React, { useEffect } from 'react';
import { Shield } from 'lucide-react';

const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-br from-primary-dark via-primary to-accent py-16">
        <div className="container mx-auto px-4 text-center text-white">
          <Shield className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-5xl font-extrabold mb-4 drop-shadow-2xl">Política de Privacidad</h1>
          <p className="text-xl font-light drop-shadow-lg">Última actualización: 19 de octubre de 2025</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg">
            <div className="prose prose-lg max-w-none
              [&>h2]:text-2xl [&>h2]:font-bold [&>h2]:text-primary [&>h2]:mt-8 [&>h2]:mb-4 [&>h2]:pb-2 [&>h2]:border-b-2 [&>h2]:border-accent/30
              [&>p]:text-gray-700 [&>p]:leading-relaxed [&>p]:mb-4
              [&>ul]:list-disc [&>ul]:list-inside [&>ul]:space-y-2 [&>ul]:mb-4 [&>ul]:text-gray-700
              [&>ul>li]:ml-4">
              <p>Esta Política de privacidad describe cómo Trabajo Fuera Ltd ("Trabajo Fuera") trata los datos personales cuando usted utiliza trabajofuera.com o se comunica con nosotros. El punto de contacto principal es Hamish Jefford.</p>

              <h2>1. Responsable del tratamiento</h2>
              <ul>
                <li>Responsable: Trabajo Fuera Ltd (Company Number 16724382)</li>
                <li>Domicilio social: 8 Pinfold Court, Chester, UK, CH4 7ES</li>
                <li>Correo electrónico: info@trabajofuera.com</li>
                <li>Teléfono: +34 678 601 100</li>
              </ul>

              <h2>2. Ámbito normativo y bases jurídicas</h2>
              <p>Aplicamos el UK GDPR y la Data Protection Act 2018 para el tratamiento realizado bajo la legislación del Reino Unido. Dado que el sitio se dirige a residentes en España, cuando corresponda aplicamos también el Reglamento (UE) 2016/679 (RGPD). Las bases jurídicas principales son el consentimiento, la ejecución de un contrato o la aplicación de medidas precontractuales, el cumplimiento de obligaciones legales y el interés legítimo, según proceda.</p>

              <h2>3. Finalidades y plazos de conservación</h2>
              <ul>
                <li>Gestión de consultas y comunicaciones (formularios, correo o teléfono). Conservación: mientras se mantenga la relación y, en su caso, durante los plazos legales de prescripción.</li>
                <li>Prestación de servicios de orientación/colocación laboral y procesos precontractuales/contractuales. Conservación: durante la vigencia del servicio y plazos legales.</li>
                <li>Mejora del sitio y seguridad. Conservación: según criterios técnicos de seguridad y logs.</li>
              </ul>

              <h2>4. Categorías de datos</h2>
              <p>Datos identificativos y de contacto; información profesional y curricular facilitada voluntariamente; datos técnicos mínimos de acceso (p. ej., direcciones IP y registros de servidor).</p>

              <h2>5. Destinatarios y encargados del tratamiento</h2>
              <p>Podemos compartir datos con proveedores que actúan como encargados del tratamiento para alojamiento y comunicaciones:</p>
              <ul>
                <li>Alojamiento web/CDN: Netlify (como proveedor de hosting/CDN).</li>
                <li>Correo y comunicaciones: servicios de correo asociados a nuestro dominio.</li>
              </ul>
              <p>Actualmente no utilizamos herramientas de analítica ni CRM. No cedemos datos a terceros salvo obligación legal o consentimiento. Si, en función de la infraestructura del proveedor o de la red de distribución de contenidos, se produjeran transferencias internacionales fuera del Reino Unido/EEE, aplicaremos garantías adecuadas (por ejemplo, cláusulas contractuales tipo) y evaluaciones de impacto de transferencias cuando proceda.</p>

              <h2>6. Cookies</h2>
              <p>Utilizamos únicamente cookies o tecnologías similares estrictamente necesarias para el funcionamiento básico del sitio. Si en el futuro incorporamos cookies no esenciales, solicitaremos su consentimiento previo y actualizaremos esta Política.</p>

              <h2>7. Seguridad</h2>
              <p>Aplicamos medidas técnicas y organizativas para proteger los datos contra accesos no autorizados, pérdidas o alteraciones.</p>

              <h2>8. Derechos de las personas</h2>
              <p>Puede ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad, así como retirar su consentimiento en cualquier momento, escribiendo a info@trabajofuera.com. Responderemos de acuerdo con los plazos legales aplicables.</p>

              <h2>9. Reclamaciones</h2>
              <p>Si considera que no hemos tratado sus datos correctamente, puede contactarnos primero. También puede reclamar ante la Information Commissioner's Office (ICO, Reino Unido) y, cuando corresponda, ante la Agencia Española de Protección de Datos (AEPD) u otra autoridad competente de su lugar de residencia en la UE/EEE.</p>

              <h2>10. Representante en la UE/EEE</h2>
              <p>Estamos en proceso de designar un representante en la UE conforme al artículo 27 del RGPD. Publicaremos los datos de contacto del representante y actualizaremos esta Política cuando el nombramiento sea efectivo.</p>

              <h2>11. Contacto</h2>
              <p>Para cuestiones de privacidad, escriba a info@trabajofuera.com (a la atención de Hamish Jefford).</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
